/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (ARS - Route Selections)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form state values for ARS module.

────────────────────────────────────────────────────────────────*/

import { FormState, RouteFormState } from '../types';

/**
 * Create client ID for route form state
 */
export function createClientId(): string {
  return `route-${crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`}`;
}

/**
 * Create empty route form state
 */
export function createEmptyRoute(priority: number): RouteFormState {
  return {
    clientId: createClientId(),
    outboundRouteId: null,
    timeGroupId: null,
    priority,
    enabled: true
  };
}

/**
 * Default form state
 */
export function getDefaultFormState(): FormState {
  return {
    name: '',
    description: '',
    enabled: true,
    routes: []
  };
}

/**
 * Apply sequential priorities to routes
 */
export function applySequentialPriorities(routes: RouteFormState[]): RouteFormState[] {
  return routes.map((route, index) => ({ ...route, priority: index + 1 }));
}

